window.Reedsy = window.Reedsy || {};
Reedsy.Discovery = Reedsy.Discovery || {};

class StickyMenuHandler {
  constructor() {
    setTimeout(this.initialize.bind(this), 200);
  }

  initialize() {
    this._scrollingElement = document.scrollingElement ?
                              document.scrollingElement :
                              document.documentElement;

    this._stickyElements = this.getStickyElements();
    if (!this._stickyElements.stickyMenu && !this._stickyElements.actions.length) {
      return;
    }

    this._currentScrollTop = this._scrollingElement.scrollTop;

    window.addEventListener('scroll', this.windowScrollPerformed.bind(this));
    this.windowScrollPerformed();
  }

  getStickyElements() {
    const stickyElements = {
      actions: [],
    };

    const stickyMenu = document.querySelector('.sticky-menu.enable');
    if (stickyMenu) {
      stickyElements.stickyMenu = {
        element: stickyMenu,
        hideAtPosition: (stickyMenu.dataset.hideAtPosition) ? stickyMenu.dataset.hideAtPosition : null,
      };

      if (!stickyElements.stickyMenu.hideAtPosition) {
        this.toggleStickyActions(stickyElements.stickyMenu.element, true);
      }
    }

    const actionsElements = document.querySelectorAll('.sticky-actions.enable');
    [].forEach.call(actionsElements, (actionsElement) => {
      if (actionsElement.dataset.hideAtPosition || actionsElement.dataset.showAtPosition) {
        stickyElements.actions.push({
          element: actionsElement,
          hideAtPosition: actionsElement.dataset.hideAtPosition,
          showAtPosition: actionsElement.dataset.showAtPosition,
          showOnlyOnScrollUp: actionsElement.dataset.showOnlyOnScrollUp,
        });
      }
    });

    return stickyElements;
  }

  toggleStickyActions(actionsElement, shouldShow) {
    actionsElement.classList.toggle('show', shouldShow);
  }

  windowScrollPerformed() {
    const newScrollTop = this._scrollingElement.scrollTop;

    // Only fire if the scroll changes more than 10px
    if (Math.abs(newScrollTop - this._currentScrollTop) <= 10)
    {
      return;
    }

    if (this._stickyElements.stickyMenu && this._stickyElements.stickyMenu.hideAtPosition) {
      const shouldShowMenu = (newScrollTop < this._stickyElements.stickyMenu.hideAtPosition) ||
                             (newScrollTop < this._currentScrollTop);

      this.toggleStickyActions(this._stickyElements.stickyMenu.element, shouldShowMenu);
    }

    this._stickyElements.actions.forEach((actionsElement) => {
      let shouldShowActions;

      if ((actionsElement.showOnlyOnScrollUp === 'true') &&
            newScrollTop > this._currentScrollTop) {
        shouldShowActions = false;
      } else if (actionsElement.hideAtPosition && actionsElement.showAtPosition) {
        shouldShowActions = (newScrollTop < actionsElement.hideAtPosition) &&
                              (newScrollTop > actionsElement.showAtPosition);
      } else {
        shouldShowActions = actionsElement.hideAtPosition && (newScrollTop < actionsElement.hideAtPosition) ||
                              actionsElement.showAtPosition && (newScrollTop > actionsElement.showAtPosition);
      }

      this.toggleStickyActions(actionsElement.element, shouldShowActions);
    });

    this._currentScrollTop = newScrollTop;
  }
}


Reedsy.Discovery.StickyMenuHandler = new StickyMenuHandler();
